namespace SolovisGateway.Admin.Authentication {

    export class JwtAuthAppDetailsControl extends Solovis.UI.BaseControl {

        private _jwtAuthApp: JwtAuthAppModel;
        private _allUsers: Array<JwtAuthAppUserModel>;
        private _jwtAuthAppUsers: Array<JwtAuthAppUserModel>;
        private _initError;

        private _jwtAuthAppCode: string;

        private _dataGrid: DevExpress.ui.dxDataGrid;

        constructor(options, jwtAuthAppCode: string) {
            super(options);
            this._jwtAuthAppCode = jwtAuthAppCode;
            this._allUsers = new Array<JwtAuthAppUserModel>();
            this._jwtAuthAppUsers = new Array<JwtAuthAppUserModel>();
        }

        public async doInitAsync() {
            let self = this;

            let promises = new Array<Promise<any>>();

            promises.push(Solovis.Rpc.invoke(
                "~/Admin/UserAdmin/GetUsers",
                {},
                function (response, success) {
                    if (success
                        && response
                        && response.result
                        && response.result.users) {

                        response.result.users.forEach(user => {
                            let model = new JwtAuthAppUserModel(user);
                            self._allUsers.push(model);
                        });
                    }
                    else {
                        console.log("ERROR: JwtAuthAppDetailsControl.doInitAsync");
                        console.log(response.error);
                        self._initError = response.error;
                    }
                })); 

            promises.push(Solovis.Rpc.invoke(
                "~/Rpc/AuthIntegration/GetJwtAuthApp",
                { jwtAuthAppCode: this._jwtAuthAppCode },
                function (response, success) {
                    if (success
                        && response
                        && response.result
                        && response.result.jwtAuthApp) {

                        self._jwtAuthApp = new JwtAuthAppModel(response.result.jwtAuthApp);
                    }
                    else {
                        console.log("ERROR: JwtAuthAppDetailsControl.doInitAsync");
                        console.log(response.error);
                        self._initError = response.error;
                    }
                }));

            promises.push(Solovis.Rpc.invoke(
                "~/Rpc/AuthIntegration/GetJwtAuthAppUsers",
                { jwtAuthAppCode: this._jwtAuthAppCode },
                function (response, success) {
                    if (success
                        && response
                        && response.result
                        && response.result.users) {

                        response.result.users.forEach(user => {
                            let model = new JwtAuthAppUserModel(user);
                            self._jwtAuthAppUsers.push(model);
                        });
                    }
                    else {
                        console.log("ERROR: JwtAuthAppDetailsControl.doInitAsync");
                        console.log(response.error);
                    }
                }));

            return Promise.all(promises);
        }

        public doRender() {
            let headerDiv = $("<div>").appendTo(this.container);
            let header = $("<h2>").text(this._jwtAuthApp.name).appendTo(headerDiv);
          
            if (this._jwtAuthApp.canHaveUsers) {
                this._renderUsersGrid();
            }
        }

        private _renderUsersGrid() {
            let self: JwtAuthAppDetailsControl = this;

            let detailStore = new DevExpress.data.ArrayStore({
                key: 'id',
                data: self._jwtAuthAppUsers
            });

            let usersStore = new DevExpress.data.ArrayStore({
                key: 'id',
                data: self._allUsers
            });

            let dataGridContainer = $("<div>").appendTo(this.container);

            dataGridContainer = $("<div>")
                .dxDataGrid({
                    dataSource: {
                        store: detailStore,
                        sort: 'fullName'
                    },

                    allowColumnResizing: true,
                    allowColumnReordering: true,
                    rowAlternationEnabled: true,
                    searchPanel: { visible: true },
                    columnChooser: { enabled: false },
                    editing: {
                        mode: "form",
                        allowDeleting: true,
                        allowAdding: true
                    },

                    onRowRemoving: self._onRowRemovingHandler.bind(self),
                    onRowInserting: self._onRowInsertingHandler.bind(self),
                    onEditorPreparing: (e) => {
                        if (e.dataField == "primaryEmail") {
                            e.editorName = "dxSelectBox";
                            e.editorOptions.dataSource = {
                                store: usersStore
                            };
                            e.editorOptions.displayExpr = "primaryEmail"
                            e.editorOptions.searchEnabled = true;
                        }
                    },

                    onToolbarPreparing: function (e) {
                        let dataGrid = e.component;

                        e.toolbarOptions.items.unshift({
                            location: "before",
                            template: function () {
                                return $("<div/>")
                                    .addClass("informer")
                                    .append(
                                        $("<div>")
                                            .css("padding-left", "7px")
                                            .html(`<b>Users</b>`)
                                    );
                            }
                        });
                    },

                    width: "100%",

                    columns: [
                        {
                            dataField: 'fullName',
                            dataType: 'string',
                            caption: 'Name',
                            allowSorting: true,
                            formItem: {
                                visible: false
                            }
                        },
                        {
                            dataField: 'primaryEmail',
                            dataType: 'string',
                            caption: 'Email',
                            allowSorting: true
                        }
                    ]
                })
                .appendTo(self.container);

            self._dataGrid = dataGridContainer.dxDataGrid("instance");
        }

        private _onRowRemovingHandler(e: any) {
            let deferred = $.Deferred();
            if (e.data) {
                let data = <JwtAuthAppUserModel>e.data;
                Solovis.Rpc.invoke(
                    "~/Rpc/AuthIntegration/DeleteJwtAuthAppUser",
                    data.toDeleteParams(this._jwtAuthApp.code),
                    function (response, success) {
                        if (success) {
                            deferred.resolve();
                        }
                        else {
                            console.log('ERROR: JwtAuthAppDetailsControl._onRowRemovingHandler');
                            console.log(response.error);
                            deferred.reject(response.error.message);
                        }
                    });
            }

            e.cancel = deferred;
        }

        private _onRowInsertingHandler(e: any) {
            let deferred = $.Deferred();

            if (e.data && e.data.primaryEmail) {
                let data = new JwtAuthAppUserModel(e.data.primaryEmail);
                Solovis.Rpc.invoke(
                    "~/Rpc/AuthIntegration/AddJwtAuthAppUser",
                    data.toAddParams(this._jwtAuthApp.code),
                    function (response, success) {
                        if (success) {
                            e.data = data;
                            deferred.resolve();
                        }
                        else {
                            console.log('ERROR: JwtAuthAppDetailsControl._onRowInsertingHandler');
                            console.log(response.error);
                            deferred.reject(response.error.message);
                        }
                    });
            }

            e.cancel = deferred;
        }
    }
}